@for (checkData of checks; track checkData.name) {
    <div
        class="tw-flex tw-items-center"
        [ngClass]="check()[checkData.name] ? 'text-success' : 'text-danger'">
        <mat-icon fontSet="material-symbols-outlined">{{
            check()[checkData.name] ? 'check' : 'exclamation'
        }}</mat-icon>
        {{ checkData.translationKey | translate }}
    </div>
}
